import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./PrivacySection.module.scss";
import LogoHeader from "../../Home/HomePageImages/LogoHeader.png";

export const PrivacySection = () => {
  return (
    <>
      <div className={styles.PrivacySection}>
        <div className={styles.Info}>
          <Link to="/">
            <img src={LogoHeader} alt="Logo" className={styles.Logo} />
          </Link>
          <p>8 (989) 299-10-10</p>
        </div>

        <div className={styles.PrivacySectionContent}>
          <h1>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
          <div className={styles.PrivacySectionContentText}>
            <div>
              <p>
                <b>
                  <span>Платформы РУМСЕЛЛЕР</span>
                </b>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>
                  г.Краснодар                                                                                                            
                      10.01.2024г.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>
                  Настоящая Политика конфиденциальности персональных данных
                  (далее — Политика конфиденциальности) разработана в
                  соответствии с положениями Конституции Российской Федерации,
                  Федерального закона от 27 июля 2006 г. N 149-ФЗ «Об
                  информации, информационных технологиях и о защите информации»,
                  Федерального закона от 27 июля 2006 г. N 152-ФЗ «О
                  персональных данных» (далее - Закон о персональных данных) и
                  иными нормативными правовыми актами, действующими на
                  территории Российской Федерации и относится к платформе РС,
                  расположенной в информационной – телекоммуникационной сети
                  «Интернет» по адресу: https://roo
                </span>
                <span>m</span>
                <span>seller.ru/ (далее - Сайт).</span>
              </p>

              <p>
                <span>
                  Использование сервисов платформы РС означает безоговорочное
                  согласие Пользователя с настоящей Политикой и указанными в ней
                  условиями обработки его персональных данных. В случае
                  несогласия с этими условиями Пользователь должен воздержаться
                  от использования сервисов платформы РС.
                </span>
              </p>

              <p>
                <span>
                  В настоящей Политике конфиденциальности используются следующие
                  понятия:
                </span>
              </p>

              <p>
                <span>
                  ООО «РУМСЕЛЛЕР» (Румселлер, РС) - юридическое лицо, созданное
                  и осуществляющее деятельность в соответствии с
                  законодательством Российской Федерации,{" "}
                </span>
                <span>
                  ОГРН 1232300070023, ИНН 2308294780, КПП 230801001, юридический
                  адрес:{" "}
                </span>
                <span>
                  350910, Краснодарский край, г.о. город Краснодар, г.
                  Краснодар, тер. Пашковский жилой массив, ул. им. Кирова,
                  д.265, кв.188.
                </span>
              </p>

              <p>
                <span>
                  Платформа Румселлер (далее платформа РС, сайт) - веб-сайт по
                  адресу www.roomseller.ru в информационно –
                  телекоммуникационной сети Интернет, прикладные программы (в
                  том числе программы для мобильных приложений), предоставляющие
                  доступ к базе данных в пределах конкретных потребностей для
                  соответствующего взаимодействия Поставщиков и Продавцов в
                  целях последующей реализации товаров конечным потребителям с
                  использованием дистанционного способа (дистанционной
                  торговли), т.е. через маркетплейсы.{" "}
                </span>
              </p>

              <p>
                <span>
                  База данных представляет собой информационно-справочную
                  систему со всеми приложениями, содержащую информацию
                  Поставщиков о товарах, предназначенную для Продавцов,
                  осуществляющих продажи этих товаров через маркетплейсы
                  Конечным Потребителям.
                </span>
              </p>

              <p>
                <span>
                  В целях правильного толкования настоящей Политики
                  конфиденциальности в случае, когда речь идет о юридически
                  значимых действиях, под платформой РС имеется ввиду также ООО
                  «Румселлер».
                </span>
              </p>

              <p>
                <span>
                  - Сайт, веб-сайт - это интерактивный набор страниц,
                  расположенный на доменном имени https://roo
                </span>
                <span>m</span>
                <span>seller.ru/.</span>
              </p>

              <p>
                <span>
                  - Пользователь сайта - физическое лицо / индивидуальный
                  предприниматель/ самозанятый/ представитель юридического лица,
                  пользователь услуг сайта, субъект персональных данных,
                  добровольно зарегистрировавшийся на сайте и предоставивший
                  необходимые персональные данные при регистрации.
                </span>
              </p>

              <p>
                <span>
                  - Персональные данные - любая информация, относящаяся прямо
                  или косвенно к определенному или определяемому физическому
                  лицу (субъекту персональных данных);
                </span>
              </p>

              <p>
                <span>
                  - Обработка персональных данных - любое действие (операция)
                  или совокупность действий (операций), совершаемых с
                  использованием средств автоматизации или без использования
                  таких средств с персональными данными, включая сбор, запись,
                  систематизацию, накопление, хранение, уточнение (обновление,
                  изменение), извлечение, использование, передачу
                  (распространение, предоставление, доступ), обезличивание,
                  блокирование, удаление, уничтожение персональных данных.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <strong>1. ОБЩИЕ ПОЛОЖЕНИЯ</strong>
              </p>

              <p>
                <span>
                  1.1. В рамках настоящей Политики под персональной информацией
                  (персональными данными) Пользователя понимаются:
                </span>
              </p>

              <p>
                <span>
                  1.1.1. Персональная информация, которую Пользователь
                  предоставляет о себе самостоятельно в процессе использования
                  сервисов платформы РС, включая персональные данные
                  Пользователя. Обязательная для предоставления сервисов
                  платформы РС информация помечена специальным образом.
                  Пользователь обязан указать достоверные данные о себе при
                  регистрации на платформе РС. Указание Пользователем
                  недостоверных, некорректных, несуществующих номера телефона,
                  адреса электронной почты, ФИО Пользователя, а также других
                  недостоверных сведений признается Румселлером недобросовестным
                  поведением и влечет за собой отказ в регистрации на платформе
                  РС (предоставлении личного кабинета) или расторжение Договора
                  - оферты, заключенного с Пользователем.
                </span>
              </p>

              <p>
                <span>
                  1.1.2. Данные, которые автоматически передаются сервисами
                  платформы РС в процессе их использования с помощью
                  установленного на устройстве Пользователя программного
                  обеспечения, в том числе IP-адрес, данные файлов cookie,
                  информация о браузере Пользователя (или иной программе, с
                  помощью которой осуществляется доступ к сервисам), технические
                  характеристики оборудования и программного обеспечения,
                  используемых Пользователем, дата и время доступа к сервисам,
                  адреса запрашиваемых страниц и иная подобная информация.
                </span>
              </p>

              <p>
                <span>
                  1.2. Настоящая Политика конфиденциальности применяется только
                  к платформе РС по адресу в сети Интернет https://roo
                </span>
                <span>m</span>
                <span>
                  seller.ru/. Платформа РС не контролирует и не несет
                  ответственности за сайты третьих лиц, на которые Пользователь
                  может перейти по ссылкам, доступным на платформе РС.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <strong>
                  2. ЦЕЛИ СБОРА И ОБРАБОТКИ ПЕРСОНАЛЬНОЙ ИНФОРМАЦИИ
                  ПОЛЬЗОВАТЕЛЕЙ
                </strong>
              </p>

              <p>
                <span>
                  2.1. Платформа РС собирает и хранит только ту персональную
                  информацию, которая необходима для предоставления сервисов или
                  исполнения договоров с Пользователями, за исключением случаев,
                  когда законодательством предусмотрено обязательное хранение
                  персональной информации в течение определенного законом срока.
                </span>
              </p>

              <p>
                <span>
                  Сбор персональных данных Пользователей осуществляется на
                  платформе РС при регистрации, а также в дальнейшем при
                  внесении Пользователем по своей инициативе дополнительных
                  сведений о себе с помощью инструментария платформы РС.
                </span>
              </p>

              <p>
                <span>
                  Осуществляя регистрацию на платформе РС в порядке,
                  предусмотренном Правилами использования сервиса платформы
                  РУМСЕЛЛЕР и соответствующим Договором - офертой, Пользователь
                  выражает бесспорное согласие ООО «Румселлер» с настоящей
                  политикой и дает согласие на обработку своих персональных
                  данных.
                </span>
              </p>

              <p>
                <span>
                  В случае несогласия с настоящей политикой регистрация на
                  платформе РС Пользователя не производится, личный кабинет
                  Пользователя РС не открывается.
                </span>
              </p>

              <p>
                <span>
                  При направлении Пользователем уведомления об отзыве согласия
                  на обработку персональных данных использование им сервисов
                  платформы РС должно быть немедленно прекращено, в этом случае
                  Платформа РС прекращает обработку персональных данных
                  Пользователя в срок, предусмотренный действующим
                  законодательством.
                </span>
              </p>

              <p>
                <span>
                  Отзыв согласия на обработку персональных данных является
                  основанием для одностороннего расторжения во внесудебном
                  порядке Договора - оферты, заключенного с Пользователем.
                </span>
              </p>

              <p>
                <span>
                  Уведомление об отзыве согласия на обработку персональных
                  данных направляется на адрес электронной почты: info@roo
                </span>
                <span>m</span>
                <span>
                  seller.ru, а также путем письменного обращения по юридическому
                  адресу ООО «РУМСЕЛЛЕР».
                </span>
              </p>

              <p>
                <span>
                  2.2. Персональную информацию Пользователя платформа РС
                  обрабатывает в следующих целях:
                </span>
              </p>

              <p>
                <span>
                  2.2.1. Идентификации Пользователя, зарегистрированного на
                  платформе РС;
                </span>
              </p>

              <p>
                <span>
                  2.2.2. Обеспечения доступа Пользователей к функционалу
                  платформы РС и обеспечения возможности использования
                  соответствующего функционала;
                </span>
              </p>

              <p>
                <span>
                  2.2.3. Поддержания работоспособности, технического
                  обслуживания, улучшения функциональности платформы РС и
                  обеспечивающих ее функционирование систем;
                </span>
              </p>

              <p>
                <span>
                  2.2.4. Защиты и осуществления прав и законных интересов
                  платформы РС, а также прав и законных интересов Пользователей,
                  в том числе для защиты от мошеннических действий третьих лиц,
                  при условии, что при этом не нарушаются права и свободы
                  Пользователей.
                </span>
              </p>

              <p>
                <span>
                  2.2.5. Исполнения требований применимого к деятельности
                  платформы РС законодательства;
                </span>
              </p>

              <p>
                <span>
                  2.2.6. Исполнения обязательств платформы РС перед
                  Пользователями в соответствии с Правилами использования
                  сервиса платформы РС, доступными по ссылкам на платформе РС.
                </span>
                <a></a>
              </p>

              <p>
                <span>
                  2.2.7. Заключения, исполнения и прекращения Договоров –
                  оферты, заключенных с Пользователями.{" "}
                </span>
              </p>

              <p>
                <span>
                  2.2.8. Осуществления статистических и аналитических
                  исследований с целью оказания помощи Пользователям в
                  увеличении объема продаж, при условии обязательного
                  обезличивания персональных данных.
                </span>
              </p>

              <p>
                <span>
                  2.2.9. Осуществления контактов с Пользователем по указанным им
                  каналам связи, в том числе для аналитики его действий на
                  платформе РС, обработки входящих и исходящих запросов,
                  направления информации о продуктах и услугах, выполнения
                  условий договоров (в т.ч. заказов), проводимых им в процессе
                  использования сервисов платформы РС.
                </span>
              </p>

              <p>
                <span>
                  2.2.10. Осуществления рекламной деятельности с согласия
                  Пользователя.
                </span>
              </p>

              <p>
                <span>
                  2.3. Обработка персональных данных осуществляется на основе
                  принципов:{" "}
                </span>
              </p>

              <p>
                <span>
                  а) законности целей и способов обработки персональных данных;{" "}
                </span>
              </p>

              <p>
                <span>б) добросовестности; </span>
              </p>

              <p>
                <span>
                  в) соответствия целей обработки персональных данных целям,
                  заранее определенным и заявленным при сборе персональных
                  данных, а также полномочиям платформы РС;{" "}
                </span>
              </p>

              <p>
                <span>
                  г) соответствия объема и характера обрабатываемых персональных
                  данных, способов обработки персональных данных целям обработки
                  персональных данных;{" "}
                </span>
              </p>

              <p>
                <span>
                  д) недопустимости объединения созданных для несовместимых
                  между собой целей баз данных, содержащих персональные данные.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <strong>3. УСЛОВИЯ ХРАНЕНИЯ, ОБРАБОТКИ ПЕРСОНАЛЬНОЙ</strong>
              </p>

              <p>
                <span>
                  ИНФОРМАЦИИ ПОЛЬЗОВАТЕЛЕЙ И ЕЕ ПЕРЕДАЧИ ТРЕТЬИМ ЛИЦАМ
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>
                  3.1. Платформа РС хранит персональную информацию Пользователей
                  в соответствии с внутренними регламентами конкретных сервисов.
                  Персональные данные Покупателей хранятся исключительно на
                  электронных носителях.
                </span>
              </p>

              <p>
                <span>
                  В отношении персональной информации Пользователя сохраняется
                  конфиденциальность, кроме случаев добровольного предоставления
                  Пользователем информации о себе для общего доступа
                  неограниченному кругу лиц. При использовании отдельных
                  сервисов Пользователь соглашается с тем, что определенная
                  часть его персональной информации становится общедоступной.
                </span>
              </p>

              <p>
                <span>
                  3.2. Платформа РС осуществляет обработку персональных данных с
                  использованием средств автоматизации и без использования
                  средств автоматизации
                </span>
              </p>

              <p>
                <span>
                  3.3. Обработка персональных данных Пользователя осуществляется
                  без ограничения срока следующими способами: сбор, запись,
                  систематизация, накопление, хранение, уточнение (обновление,
                  изменение), извлечение, использование, передача
                  (распространение, предоставление, доступ), обезличивание,
                  блокирование, удаление, уничтожение персональных данных, в том
                  числе в информационных системах персональных данных с
                  использованием средств автоматизации или без использования
                  таких средств. Обработка персональных данных Пользователей
                  осуществляется в соответствии с Федеральным законом от
                  27.07.2006 № 152-ФЗ  «О персональных данных».
                </span>
              </p>

              <p>
                <span>
                  3.4. Платформа РС вправе передать персональную информацию
                  Пользователя третьим лицам в следующих случаях:
                </span>
              </p>

              <p>
                <span>
                  3.4.1. Пользователь выразил согласие на такие действия.
                </span>
              </p>

              <p>
                <span>
                  3.4.2. Передача необходима для использования Пользователем
                  определенного сервиса либо для исполнения определенного
                  договора (заказа) с другим Пользователем.
                </span>
              </p>

              <p>
                <span>
                  3.4.3. Передача предусмотрена российским или иным применимым
                  законодательством в рамках установленной законодательством
                  процедуры.
                </span>
              </p>

              <p>
                <span>
                  3.5. При утрате или разглашении персональных данных Платформа
                  РС незамедлительно информирует Пользователя об утрате или
                  разглашении персональных данных.
                </span>
              </p>

              <p>
                <span>
                  3.6. Платформа РС принимает необходимые организационные и
                  технические меры для защиты персональной информации
                  Пользователя от неправомерного или случайного доступа,
                  уничтожения, изменения, блокирования, копирования,
                  распространения, а также от иных неправомерных действий
                  третьих лиц.
                </span>
              </p>

              <p>
                <span>
                  3.7. Платформа РС совместно с Пользователем принимает все
                  необходимые меры предотвращению убытков или иных отрицательных
                  последствий, вызванных утратой или разглашением персональных
                  данных Пользователя.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <strong>
                  4.СВЕДЕНИЯ О РЕАЛИЗУЕМЫХ ТРЕБОВАНИЯХ К ЗАЩИТЕ ПЕРСОНАЛЬНЫХ
                  ДАННЫХ
                </strong>
              </p>

              <p>
                <span>
                  4.1. Важнейшим условием реализации целей деятельности
                  платформы РС является обеспечение необходимого и достаточного
                  уровня безопасности информационных систем персональных данных,
                  соблюдения конфиденциальности, целостности и доступности
                  обрабатываемых персональных данных и сохранности носителей
                  сведений, содержащих персональные данные на всех этапах работы
                  с ними.
                </span>
              </p>

              <p>
                <span>
                  4.2. Пользователь платформы РС получает индивидуальную
                  идентификацию путем ввода логина и пароля, указанного при
                  регистрации и открытии личного кабинета на платформе РС .
                  Индивидуальная идентификация Пользователя позволяет избежать
                  несанкционированных действий третьих лиц от имени Пользователя
                  и открывает доступ к дополнительным сервисам. Передача
                  Пользователем этих данных для доступа третьим лицам запрещена.
                  Пользователь несёт ответственность за все возможные негативные
                  последствия в случае передачи учетных данных для доступа в
                  Личный кабинет третьим лицам.
                </span>
              </p>

              <p>
                <span>
                  4.3. Платформа РС использует современные технологии
                  шифрования, обеспечивающие защиту личной информации в
                  определенных областях веб-сайтов платформы РС во время
                  передачи через Интернет.
                </span>
              </p>

              <p>
                <span>
                  4.4. Созданные у платформы РС условия и режим защиты
                  информации, отнесенной к персональным данным, позволяют
                  обеспечить защиту обрабатываемых персональных данных.
                </span>
              </p>

              <p>
                <span>
                  4.5. Предприняты необходимые и достаточные технические меры
                  для обеспечения безопасности персональных данных от случайного
                  или несанкционированного доступа, уничтожения, изменения,
                  блокирования доступа и других несанкционированных действий:
                </span>
              </p>

              <p>
                <span>
                  4.6. Установлена защита от несанкционированного доступа к
                  автоматизированным рабочим местам, информационным сетям и
                  базам персональных данных.
                </span>
              </p>

              <p>
                <span>
                  4.7. Установлена защита от вредоносного
                  программно-математического воздействия.
                </span>
              </p>

              <p>
                <span>
                  4.8. Осуществляется регулярное резервное копированием
                  информации и баз данных.
                </span>
              </p>

              <p>
                <span>
                  4.9. Передача информации по сетям общего пользования
                  осуществляется с использованием средств криптографической
                  защиты информации.
                </span>
              </p>

              <p>
                <span>
                  4.10. Организована система контроля за порядком обработки
                  персональных данных и обеспечения их безопасности.
                  Спланированы проверки соответствия системы защиты персональных
                  данных, аудит уровня защищенности персональных данных в
                  информационных системах персональных данных, функционирования
                  средств защиты информации, выявления изменений в режиме
                  обработки и защиты персональных данных.{" "}
                </span>
              </p>

              <p>
                <span>
                  4.11. Доступ Пользователя в личный кабинет может быть
                  ограничен платформой РС в случаях, если платформе РС станут
                  известны сведения о том, что в личном кабинете Пользователя
                  проведены или могут проводиться транзакции с использованием
                  платежных средств третьих лиц без их ведома, либо сведения о
                  том, что Пользователем скомпрометированы персональные данные
                  для входа в личный кабинета со стороны лиц, которые могут быть
                  причинить вред неопределённому кругу третьих лиц, либо самому
                  Пользователю, в частности, если в личном кабинете могли
                  распространяться сведения, составляющие террористическую
                  угрозу, призывы к насилию, либо если личный кабинет мог
                  использоваться в целях совершения уголовно-наказуемых деяний,
                  либо если платформе РС стали известны сведения о том, что
                  Покупатель использовал чужие персональные данные для
                  осуществления противоправной, преступной деятельности.
                </span>
              </p>

              <p>
                <span>
                  4.12. Платформа РС не несёт ответственности за вред, который
                  может быть причинён Пользователем третьим лицам.
                </span>
              </p>

              <p>
                <span>
                  4.13. Платформа РС обязана осуществить блокирование
                  персональных данных, относящихся к соответствующему
                  Пользователю, с момента обращения или запроса Пользователя или
                  его законного представителя либо уполномоченного органа по
                  защите прав субъектов персональных данных на период проверки в
                  случае выявления недостоверных персональных данных или
                  неправомерных действий.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <strong>5. ДОСТУП К ПОЛИТИКЕ И ЕЕ АКТУАЛИЗАЦИЯ</strong>
              </p>

              <p>
                <span>
                  5.1. Электронная версия действующей редакции Политики
                  размещена по адресу:{" "}
                </span>
                <a></a>
                <a href="https://roomseller.ru/terms">
                  <span>https://roomseller.ru/term</span>
                  <span>s</span>
                </a>
                <span>.</span>
              </p>

              <p>
                <span>
                  5.2. Платформа РС имеет право вносить изменения в настоящую
                  Политику. При внесении изменений в наименовании Политики
                  указывается дата последнего обновления редакции. Новая
                  редакция Политики вступает в силу с момента ее размещения на
                  платформе РС, если иное не предусмотрено новой редакцией
                  Политики.
                </span>
              </p>

              <p>
                <span>
                  5.3.К настоящей Политике и отношениям между субъектом
                  персональных данных и платформой РС применяются нормы
                  действующего законодательства Российской Федерации.
                </span>
              </p>

              <p>
                <span>
                  5.4. Актуальная версия Политики действует бессрочно до замены
                  её новой версией.
                </span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>

              <p>
                <span>&nbsp;</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
